<div class="banner">
  <div class="main-container wrap">
    <i class="material-icons cloud">cloud</i>
    <div class="info">
      <span class="title">{{ 'PAGES.CREATE_NEW_TEMPLATE.CREATE_BANNER.TITLE' | translate }} +</span>
      <br />
      <p>
        {{ 'PAGES.CREATE_NEW_TEMPLATE.CREATE_BANNER.SUBTITLE' | translate }}
      </p>
    </div>
  </div>
</div>

<mat-card appearance="outlined" class="page page-narrow">
  <mat-card-header>
    <mat-card-title>
      {{ 'PAGES.CREATE_NEW_TEMPLATE.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form (ngSubmit)="onSubmit(); (false)">
      <p>
        <mat-form-field class="create-full-width">
          <input
            matInput
            type="text"
            [required]="true"
            name="siteTitle"
            [(ngModel)]="formFields.siteTitle"
            placeholder="{{ 'PAGES.MANAGE_TEMPLATES.CREATE.NAME' | translate }}"
            maxlength="{{ maxLength }}"
            />
          @if (!!formFields.siteTitle && formFields.siteTitle.length > maxLength - 15) {
            <mat-hint>
              {{ 'PAGES.CREATE.CHARACTERS_REMAINING' | translate }}:
              {{ calculateRemainingChars(formFields.siteTitle.length) }}
            </mat-hint>
          }
        </mat-form-field>
      </p>
      <p>
        <mat-form-field class="create-full-width">
          <input
            matInput
            id="domain-text-input"
            type="text"
            [required]="true"
            name="defaultDomain"
            [(ngModel)]="formFields.defaultDomain"
            placeholder="{{ 'PAGES.MANAGE_TEMPLATES.CREATE.DOMAIN' | translate }}"
            />
          <span class="input-suffix" matSuffix>{{ defaultDomainSuffix }} &nbsp;</span>
          @if (
            !!formFields.defaultDomain && calculateRemainingSubdomainChars(formFields.defaultDomain.length) <= 15
            ) {
            <mat-hint
              >
              {{ 'PAGES.CREATE.CHARACTERS_REMAINING' | translate }}:
              {{ calculateRemainingSubdomainChars(formFields.defaultDomain.length) }}
            </mat-hint>
          }
        </mat-form-field>
      </p>
      <button mat-raised-button [disabled]="createDisabled" class="wide-button" type="submit" color="accent">
        {{ 'PAGES.CREATE_NEW_TEMPLATE.CREATE_TEMPLATE' | translate }}
      </button>
    </form>
  </mat-card-content>
</mat-card>
